export default __webpack_public_path__ + "static/pdp-diamond-e6d316d465b1a2150a2fa60ed177a035.svg";